module.exports = {"TXTWCL_Sorry___an_error_has_occurred":{"id":"TXTWCL_Sorry___an_error_has_occurred","defaultMessage":"Ne pare rău - a avut loc o eroare"}}